import React, { useState, useEffect, useContext } from "react"
import ShowMessage from "./ShowMessage"
import Context from "../utils/Context"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileImport } from "@fortawesome/free-solid-svg-icons"
import api from "../api/api"

export default function ModalImport() {

    const context = useContext(Context)
    const [currentMap, setCurrentMap] = useState()

    useEffect(() => {
        setCurrentMap(context.maps.find(m => m.name === context.selected.map?.name && m.robotId === context.robotInfo._id))
    }, [])

    const importTasks = () => {
        if (currentMap) {
            api.fetchTasks({ mapId: currentMap._id })
            .then(response => {
                if (response?.data) {
                    console.log(response)
                    context.actions.setAvailableTasks(response.data)
                }
            })
        context.actions.setModalState({ ...context.modalState, import: false })
        } else {
            context.actions.setMessage({ message: 'No map selected.', type: 'error' })
        }
    }

    return (
        <div className="modal is-active">
            <div className="modal-background"></div>
            <div className="modal-card" onClick={(e) => e.stopPropagation()}>

                <header className="modal-card-head">
                    <p className="modal-card-title">Import Tasks</p>
                    <button
                        className="delete"
                        aria-label="close"
                        onClick={() => context.actions.setModalState({ ...context.modalState, import: false })}
                    ></button>
                </header>

                <section className="modal-card-body">

                    <div className="field mb-5">
                        There are no tasks assigned to this map in this device.
                        <br />
                        Do you wish to import them from FMS, should they exist?
                    </div>

                </section>

                <ShowMessage />

                <footer className="modal-card-foot">
                    <button className="button is-success" onClick={importTasks}>
                        <span className="icon is-small">
                            <FontAwesomeIcon icon={faFileImport} className="fas" />
                        </span>
                        <span>Yes</span>
                    </button>
                    <button className="button" onClick={() => context.actions.setModalState({ ...context.modalState, import: false })}>
                        <span>Create new tasks</span>
                    </button>
                </footer>
            </div>
        </div>
    )
}

